import dayjs from 'dayjs'
import axios from '../../axios'
export default {
  namespaced: true,
  state: {
    events: [],
    driver_logs: [],
    dvirs: [],
    general: null,
    draws: [],
    reports: null,
    live: null,
    short: null
  },
  mutations: {
    SET_Live(state, live) {
      state.live = live
    },
    SET_LiveShort(state, live) {
      state.short = live
    },
    SET_EVENTS(state, events) {
      state.events = events;
    },
    SET_DRIVER_STATUS(state, event) {
      state.driver_logs = event
    },
    SET_DVIRS(state, dvirs) {
      state.dvirs = dvirs
    },
    SET_DRAWS(state, draws) {
      state.draws = draws
    },
    SET_GENERAL(state, general) {
      state.general = general
    },
    SET_REPORTS(state, reports) {
      state.reports = reports
    }
  },
  actions: {
    fetchDataListItems({ commit }) {
      return new Promise((resolve, reject) => {
        axios.get('event/local_data/',
          {
            headers: {
              'Content-Type': 'application/json'
            }
          }
        )
          .then((response) => {
            // console.log(response.data, "actions")
            commit('SET_EVENTS', response.data)
            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    },
    fetchDataEvents({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios.get('event/status/filter/',
          {
            params: payload
          }
        )
          .then((response) => {
            commit('SET_DRIVER_STATUS', response.data)
            let data = response.data
            let minute = 0
            let array = []
            function timeConvert(n) {
              var num = n;
              var minutes = num / 60;
              var rminutes = Math.floor(minutes);
              return rminutes;
            }
            function convertHourstoMinute(str) {
              // console.log(str);
              let [hours, minutes] = str.split(':');
              return (+hours * 60) + (+minutes) + 0
            }
            for (let index = 0; index < data.length; index++) {
              const element = data[index];
              let value = data[index].status
              minute = minute + timeConvert(element.dur)
              //  console.log('sss');
              if (value === 'OFF') {
                array.push({
                  status: 30,
                  start: null,
                  width: null,
                  id: element.id,
                  end: null
                })
              }
              else if (value === 'SB') {
                array.push({
                  status: 70,
                  width: null,
                  id: element.id,
                  start: null,
                  end: null
                })
              }
              else if (value === 'D') {
                array.push({
                  status: 110,
                  width: null,
                  start: null,
                  id: element.id,
                  end: null
                })
              }
              else {
                array.push({
                  status: 150,
                  width: null,
                  start: null,
                  id: element.id,
                  end: null
                })
              }
              if (index === 0) {
                array[index].start = convertHourstoMinute(element.cr_time.substr(11, 7))
              }
              else if (minute < 0) {
                array[index].start = 0
              }
              else if (index > 0) {
                array[index].start = array[index - 1].end
              }
              if (index === 0) {
                if (element.dur >= 86400) {
                  array[index].width = timeConvert(element.dur)
                  array[index].end = 1440
                }
                else {
                  array[index].width = timeConvert(element.dur)
                  array[index].end = convertHourstoMinute(element.cr_time.substr(11, 7)) + timeConvert(element.dur)
                }
              }
              else if (element.dur >= 86400) {
                array[index].width = 1440 - array[index - 1].end
                array[index].end = 1440
              }
              else if (data.length === index + 1) {
                array[index].width = timeConvert(element.dur)
                array[index].end = convertHourstoMinute(element.cr_time.substr(11, 7)) + timeConvert(element.dur)
              }
              else {
                array[index].width = timeConvert(element.dur)
                array[index].end = convertHourstoMinute(element.cr_time.substr(11, 7)) + timeConvert(element.dur)
              }
              //  console.log(timeConvert(element.dur), 'other', element.dur );
            }
            commit('SET_DRAWS', array)
            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    },
    fetchDataReport({ commit }, id) {
      return new Promise((resolve, reject) => {
        axios.get(`log/report_get/${id}`,
        )
          .then((response) => {
            commit('SET_REPORTS', response.data)
            let data = response.data.logs
            let minute = 0
            let array = []
            function timeConvert(n) {
              var num = n;
              var minutes = num / 60;
              var rminutes = Math.floor(minutes);
              //  console.log(rminutes, 'minustes');
              return rminutes;
            }
            function convertHourstoMinute(str) {
              // console.log(str);
              let [hours, minutes] = str.split(':');
              return (+hours * 60) + (+minutes) + 0
            }
            for (let index = 0; index < data.length; index++) {
              const element = data[index];
              let value = data[index].status
              minute = minute + timeConvert(element.dur)
              //  console.log('sss');
              if (value === 'OFF') {
                array.push({
                  status: 30,
                  start: null,
                  width: null,
                  id: element.id,
                  end: null
                })
              }
              else if (value === 'SB') {
                array.push({
                  status: 70,
                  width: null,
                  id: element.id,
                  start: null,
                  end: null
                })
              }
              else if (value === 'D') {
                array.push({
                  status: 110,
                  width: null,
                  start: null,
                  id: element.id,
                  end: null
                })
              }
              else {
                array.push({
                  status: 150,
                  width: null,
                  start: null,
                  id: element.id,
                  end: null
                })
              }
              if (index === 0) {
                array[index].start = convertHourstoMinute(element.cr_time.substr(11, 7))
              }
              else if (minute < 0) {
                array[index].start = 0
              }
              else if (index > 0) {
                array[index].start = array[index - 1].end
              }
              if (index === 0) {
                array[index].width = timeConvert(element.dur)
                array[index].end = convertHourstoMinute(element.cr_time.substr(11, 7)) + timeConvert(element.dur)
              }
              else if (element.dur > 86400) {
                array[index].width = 1440 - array[index - 1].end
                array[index].end = 1440
              }
              else if (data.length === index + 1) {
                array[index].width = timeConvert(element.dur)
                array[index].end = convertHourstoMinute(element.cr_time.substr(11, 7)) + timeConvert(element.dur)
              }
              else {
                array[index].width = timeConvert(element.dur)
                array[index].end = convertHourstoMinute(element.cr_time.substr(11, 7)) + timeConvert(element.dur)
              }
              //  console.log(timeConvert(element.dur), 'other', element.dur );
            }
            commit('SET_DRAWS', array)
            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    },
    fetchDataDvirs({ commit }, id) {
      return new Promise((resolve, reject) => {
        axios.get(`event/dvir/?log_id=${id}`,
        )
          .then((response) => {
            commit('SET_DVIRS', response.data)
            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    },
    fetchDataGeneral({ commit }, id) {
      return new Promise((resolve, reject) => {
        axios.get(`event/general_info/?log_id=${id}`,
        )
          .then((response) => {
            commit('SET_GENERAL', response.data)
            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    },
    LogStatusEdit({ _ }, payload) {
      return new Promise((resolve, reject) => {
        axios.put(`event/status/edit/${payload.id}`, payload,
        )
          .then((response) => {
            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    },
    fetchDataLive({ commit }, id) {
      return new Promise((resolve, reject) => {
        axios
          .get("event/live/long/" + id + "/")
          .then((response) => {
            commit("SET_Live", response.data);
            resolve(response);
          })
          .catch((error) => {
            console.log(error), reject(error);
          });
      });
    },
    fetchDataLiveShort({ commit }) {
      return new Promise((resolve, reject) => {
        axios
          .get("event/live/short/")
          .then((response) => {
            // console.log(response);
            commit("SET_LiveShort", response.data);
            resolve(response);
          })
          .catch((error) => {
            console.log(error), reject(error);
          });
      });
    },
  },
  getters: {
    getEvents: (state) =>
      state.events.map((event) => ({
        driver: event.driver.name + " " + event.driver.last_name,
        data: dayjs(event.start_time).format("DD,MM,YYYY") + ",  " + dayjs(event.start_time).format("HH:mm") + `  ${event.start_time.substr(11, 5) > '12:00' ? 'PM' : "AM"}`,
        vehicleid: event.driver.id,
        vehicle: event.vehicle,
        origin: event.origin.coordinates,
        duration: (new Date(event.duration * 1000)).toUTCString().match(/(\d\d:\d\d:\d\d)/)[0],
        distance: event.distance,
        destination: event.destination.coordinates,
        filter: true,
        width: 150,
      })),
  }
}